<template>
  <div class="cs-container" style="width: 100vw; height: 100vh">
    <div class="relative w-full h-full">
      <div class="absolute" style="top: 50%; left: 50%; transform: translate(-50%, -50%)">
        <div class="overflow-hidden w-80 rounded-md shadow-xl md:w-96">
          <div class="flex justify-center p-3 md:p-4" style="background-color: #3a3a3a">
            <img class="logo" src="../assets/images/logo.png" />
          </div>
          <div class="p-8">
            <div class="mb-10">
              <div class="text-5xl font-extrabold text-center">로그인</div>
              <div class="mt-2 text-center text-desc text-md md:text-lg">
                안녕하세요, 관리자 페이지 입니다.
              </div>
            </div>
            <div class="flex w-full bg-white cs-form" data-height="lg">
              <input
                class=""
                v-model="id"
                type="text"
                placeholder="아이디 입력하세요."
                @keyup.enter="onSubmit"
                @input="validateId"
              />
            </div>
            <div v-if="idError" class="mt-1 cs-feedback cs-feedback-error">
              <i class="fi fi-sr-comment-exclamation"></i><span>{{ idError }}</span>
            </div>
            <div class="flex mt-2 w-full bg-white cs-form" data-height="lg">
              <input
                class=""
                v-model="password"
                type="password"
                placeholder="비밀번호 입력하세요."
                @keyup.enter="onSubmit"
                @input="validatePassword"
              />
            </div>
            <div v-if="passwordError" class="mt-1 cs-feedback cs-feedback-error">
              <i class="fi fi-sr-comment-exclamation"></i><span>{{ passwordError }}</span>
            </div>
            <div v-if="errMassage.length" class="cs-feedback cs-feedback-error">
              <i class="fi fi-sr-comment-exclamation"></i><span>{{ errMassage }}</span>
            </div>
            <loader-button
              ref="submitLogin"
              class="mt-8 w-full cs-pd-btn-xl"
              :cssButton="'cs-btn-base'"
              :isDisabled="true"
              @loaderClick="onSubmit"
            >
              <template v-slot:title
                ><span class="text-lg font-bold md:text-xl">로그인</span></template
              >
            </loader-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {ref, watch} from "vue";
import {useRouter} from "vue-router";
import axios from "axios";
import {setCookie} from "../js/utils";
import LoaderButton from "../components/LoaderButton.vue";

const router = useRouter();
const submitLogin = ref();
const id = ref("");
const password = ref("");
const errMassage = ref("");
const idError = ref("");
const passwordError = ref("");

// 아이디 유효성 검사
const validateId = () => {
  idError.value = "";

  if (!id.value) {
    idError.value = "아이디를 입력해주세요.";
    return false;
  }

  if (id.value.length < 3) {
    idError.value = "아이디는 3자 이상 입력해주세요.";
    return false;
  }

  if (id.value.length > 20) {
    idError.value = "아이디는 20자 이하로 입력해주세요.";
    return false;
  }

  // 영문, 숫자, 특수문자 조합 검사
  const idRegex = /^[a-zA-Z0-9!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+$/;
  if (!idRegex.test(id.value)) {
    idError.value = "아이디는 영문, 숫자, 특수문자만 사용 가능합니다.";
    return false;
  }

  return true;
};

// 비밀번호 유효성 검사
const validatePassword = () => {
  passwordError.value = "";

  if (!password.value) {
    passwordError.value = "비밀번호를 입력해주세요.";
    return false;
  }

  if (password.value.length < 6) {
    passwordError.value = "비밀번호는 6자 이상 입력해주세요.";
    return false;
  }

  if (password.value.length > 50) {
    passwordError.value = "비밀번호는 50자 이하로 입력해주세요.";
    return false;
  }

  return true;
};

// 실시간 유효성 검사를 위한 watcher
watch(id, () => {
  if (validateId() && validatePassword()) {
    submitLogin.value.setDisabled(false);
  } else {
    submitLogin.value.setDisabled(true);
  }
});

watch(password, () => {
  if (validateId() && validatePassword()) {
    submitLogin.value.setDisabled(false);
  } else {
    submitLogin.value.setDisabled(true);
  }
});

const onSubmit = () => {
  // 유효성 검사 실행
  const isIdValid = validateId();
  const isPasswordValid = validatePassword();

  if (!isIdValid || !isPasswordValid) {
    if (submitLogin.value) submitLogin.value.stop();
    return;
  }

  axios
    .post("/admin/signin", {
      id: id.value,
      password: password.value,
    })
    .then((r) => {
      setCookie("token", r.data.token, {
        expires: Date.now() + 86400 * 1000,
      });
      if (submitLogin.value) submitLogin.value.stop();
      router.push({
        name: "admin-estimates",
      });
    })
    .catch(() => {
      if (submitLogin.value) {
        submitLogin.value.stop();
      }
      errMassage.value = "로그인에 실패했습니다.";
    });
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.logo {
  height: 36px;
}
</style>
